module.exports = __webpack_public_path__ + "media/images/riders/small/YANA_BELOMOINA-bbc33f883641decce4d95326b41006c4.png";